import React from 'react';
import { useStyletron } from 'baseui';
type propT = {
  strokeColor?: string;
  size?: number;
};
const Icon = ({
  strokeColor,
  size = 16
}: propT) => {
  const [_, theme] = useStyletron();
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" preserveAspectRatio="xMidYMid meet">
      <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM5.01723 12C5.01723 15.8565 8.14352 18.9828 12 18.9828C15.8565 18.9828 18.9828 15.8565 18.9828 12C18.9828 8.14352 15.8565 5.01723 12 5.01723C8.14352 5.01723 5.01723 8.14352 5.01723 12Z" fill={strokeColor ? strokeColor : 'currentColor'} />
      <circle cx="12" cy="4" r="4" fill={strokeColor ? strokeColor : 'currentColor'} />
      <circle cx="12" cy="4.00001" r="1.71429" fill={theme.colors.backgroundSecondary} />
      <circle cx="20" cy="17" r="4" fill={strokeColor ? strokeColor : 'currentColor'} />
      <circle cx="20" cy="17" r="1.71429" fill={theme.colors.backgroundSecondary} />
      <circle cx="4" cy="17" r="4" fill={strokeColor ? strokeColor : 'currentColor'} />
      <circle cx="4" cy="17" r="1.71429" fill={theme.colors.backgroundSecondary} />
    </svg>;
};
export default Icon;